export enum SORT_TYPE_OPTIONS {
    ASC = 'ASC',
    DESC = 'DESC',
}
